export default __webpack_public_path__ + "static/media/photoError.778ad328.svg";